import type { FreshbooksHubspotApi } from '@/features/freshbooks/api/freshbooks-api'

/**
 * Fetches the token that identifies the current user to HubSpot.
 */
export class HubspotTokenStore {
  constructor(private readonly _api: FreshbooksHubspotApi) {}

  /**
   * Fetches the HubSpot identification token.
   *
   * @param signal
   */
  async fetchToken(signal?: AbortSignal): Promise<string> {
    const response = await this._api.getToken(signal)
    return response.token
  }
}
